import 'gsap';
import Util from '../util/Util';
import IntersectionObserverClass from "../base/IntersectionObserverClass";


/**
 * 遅延ロード
 *
 * example->{@link ImageDelayLoadManagerClass}
 * @param {jQueryObject} _target
 * @param {Boolean} _isBg
 * @param {Boolean} _isAnim
 */
export default class ImageDelayLoadClass extends IntersectionObserverClass {
    constructor(_target,_isBg,_isAnim) {
        super(_target);
        this.spSize = Util.BREAK_POINT;
        this.isBg = _isBg;
        this.isAnim = _isAnim;
        this.windowSize;
        this.CL_LOADEND = "isLoadEnd";
        this.tweenObj;
    }

    onCreate(){
        super.onCreate();
    }

    onStop(){
        //console.log(this.name,"onStop");
        super.onStop();
        if(this.tweenObj && this.tweenObj.isActive()){
            this.tweenObj.pause();
        }
        this.tweenObj = null;
    }

    onRemove(){
        this.target.removeClass(this.CL_LOADEND);
        super.onRemove();
    }

    onActive(){
        //console.log(this.name,"onActive");
        this.onChangeBreakPoint();
    }

    onResize(size){
        this.windowSize = size;
    }

    onChangeBreakPoint(_b){
        if(!this.isActive) return;

        let self = this;
        let windowWidth = Util.getWindowWidth(true);

        let _this = self.target;
        _this.removeClass(self.CL_LOADEND);
        let src = _this.attr("data-src");
        let cl = _this.attr("class");
        if(!src) return true;
        let cSrc = null;
        if(!cl) cl = "";
        if(cl.indexOf("both") !== -1){
            self.addSrc(src);
            cSrc = src;
        } else if(windowWidth <= self.spSize && cl.indexOf("onlyPc") === -1) {
            let spsrc = _this.attr("data-src_sp");
            cSrc = (spsrc)?spsrc : Util.getSpImagePath(src);
            self.addSrc(cSrc);
        } else if(windowWidth > self.spSize && cl.indexOf("onlySp") === -1){
            self.addSrc(src);
            cSrc = src;
        }

        if(!cSrc) return true;


        let callback = function(a,b,c){
            if(!self.isLoad) return;
            self.target.addClass(self.CL_LOADEND);
        }
        let imgObj = new Image();
        imgObj.onload = callback;
        imgObj.onerror = callback;
        imgObj.src = cSrc;
    }

    addSrc(_src){
        if(this.isBg){
            this.target.css({"background-image":"url("+_src+")"});
        } else {
            this.target.attr('src', _src);
        }
    }

}